import { MouseEventHandler, useMemo } from "react"
import {
  Button,
  Flex,
  FlexProps,
  Image,
  Text,
  TextProps,
} from "@chakra-ui/react"

import rejectIcon from "#/assets/reject.svg"

export type TransactionRejectedProps = FlexProps & {
  onClick?: MouseEventHandler<HTMLButtonElement>
  showIcon?: boolean
  rejectedText?: string
  textProps?: TextProps
}

export default function TransactionRejected({
  onClick,
  showIcon = true,
  rejectedText = "Rejected",
  textProps,
  ...props
}: TransactionRejectedProps) {
  const tryAgainText = useMemo(
    () =>
      onClick ? (
        <Button
          onClick={onClick}
          variant="unstyled"
          fontWeight={500}
          textDecoration="underline"
          type="submit"
          pb="2px"
        >
          try again
        </Button>
      ) : (
        <Text as="span">try again</Text>
      ),
    [onClick],
  )

  return (
    <Flex gap={1} alignItems="center" {...props}>
      {showIcon && <Image src={rejectIcon} pb={onClick ? "4px" : 0} />}
      <Text color="primary.red.100" variant="body" {...textProps}>
        {rejectedText}, {tryAgainText}
      </Text>
    </Flex>
  )
}
